import type { SVGProps } from "react";

export function IconPurpleBarrier(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M16 49V57"
        stroke="#2A222A"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M16 28V34"
        stroke="#2A222A"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M48 28V34"
        stroke="#2A222A"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M48 49V57"
        stroke="#2A222A"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.75 13.75H6.25V27.25H57.75V13.75Z"
        fill="#2E2E2E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.8108 13.75H36.6894L23.4697 26.9698L23.1894 27.25H25.3108L38.8108 13.75ZM46.3108 27.25H44.1894L57.6894 13.75H57.75V15.8108L46.3108 27.25ZM6.31076 27.25L19.8108 13.75H17.6894L6.25 25.1894V27.25H6.31076Z"
        fill="#1C1719"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.75 34.75H6.25V48.25H57.75V34.75Z"
        fill="#2E2E2E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.8108 34.7499H37.6894L24.1894 48.2499H26.3108L39.8108 34.7499ZM46.3108 48.2499H44.1894L57.6894 34.7499H57.75V36.8107L46.3108 48.2499ZM6.31076 48.2499L19.8108 34.7499H17.6894L6.25 46.1893V48.2499H6.31076Z"
        fill="#1C1719"
      />
      <circle cx="48" cy="10" r="3" stroke="#2A222A" strokeWidth="1.5" />
      <circle cx="16" cy="10" r="3" stroke="#2A222A" strokeWidth="1.5" />
    </svg>
  );
}
